module.exports = __webpack_public_path__ + "static/media/pla_black_cocktail_straw2.5a238fb1.png";